/**
 * modules/responsive.js
 * Gestion du responsive design et adaptation selon la taille d'écran
 */

/**
 * Bascule entre le mockup MacBook et le carousel standard en fonction de la taille d'écran
 */
export function toggleMockupBasedOnScreenSize() {
    const featureCarouselContainer = document.querySelector('.feature-carousel-container');
    const isMobile = window.innerWidth < 768;
  
    if (!featureCarouselContainer) return;
  
    if (isMobile) {
      // Appliquer la classe mobile-view pour la version mobile
      featureCarouselContainer.classList.add('mobile-view');
  
      // S'assurer que les éléments mobiles sont visibles
      const mobileElements = document.querySelectorAll('.mobile-only');
      mobileElements.forEach(el => {
        el.style.display = '';
      });
  
      // Masquer les éléments desktop
      const desktopElements = document.querySelectorAll('.desktop-only');
      desktopElements.forEach(el => {
        el.style.display = 'none';
      });
  
      // Réajuster les hauteurs pour la vue mobile
      // Import et utilisation de la fonction adjustFeatureBlockHeight du module carousel
      import('./carousel.js').then(module => {
        module.adjustFeatureBlockHeight();
      });
    } else {
      // Enlever la classe mobile-view pour la version desktop
      featureCarouselContainer.classList.remove('mobile-view');
  
      // S'assurer que les éléments desktop sont visibles
      const desktopElements = document.querySelectorAll('.desktop-only');
      desktopElements.forEach(el => {
        el.style.display = '';
      });
  
      // Masquer les éléments mobiles
      const mobileElements = document.querySelectorAll('.mobile-only');
      mobileElements.forEach(el => {
        el.style.display = 'none';
      });
    }
  }